import type { FormHTMLAttributes, ReactNode } from "react";

import { DisplayState } from "@/constants/state";
import type { TInputFieldProps } from "@/ui/components/form/Input/Input.config";
import type { TButtonProps } from "@/ui/components/primitives/Button";
import type { DefinedDefaults, TWithDataComponent } from "@/ui/lib";

/*-------------------------------------
|  Types
|-------------------------------------*/

export type TNewsletterSignupProps = Omit<FormHTMLAttributes<HTMLFormElement>, "title"> & TWithDataComponent & {
  title?: ReactNode;
  body?: ReactNode;
  button?: Pick<TButtonProps, "children" | "state">;
  input?: TInputFieldProps;
};

type TNewsletterSignupDataDefaultProps = DefinedDefaults<TNewsletterSignupProps, "data-component">;

type TNewsletterSignupActionDefaultProps = DefinedDefaults<TNewsletterSignupProps, "button">;

type TNewsletterSignupDefaultProps = TNewsletterSignupDataDefaultProps &
  TNewsletterSignupActionDefaultProps;

/*-------------------------------------
|  Defaults
|-------------------------------------*/

export const NEWSLETTER_SIGNUP_DEFAULTS = {
  "data-component": "NewsletterSignup",
  button: {
    state: DisplayState.READY,
  },
} satisfies TNewsletterSignupDefaultProps;

export const NEWSLETTER_SIGNUP_DEFAULT_INPUT: TInputFieldProps = {
  name: "newsletter_email",
  type: "email",
};
